import { Component, computed, inject, input, output } from '@angular/core';
import { DashboardLayoutService } from '../../services/layout/dashboard-layout.service';
import { GridWidget } from '../grid/grid.widget';
import { GridSetup, GridSize, PageTabsMainTabGridSize } from '../grid/interfaces';

@Component({
	selector: 'grid-content',
	standalone: true,
	imports: [
		GridWidget,
	],
	templateUrl: './grid-content.widget.html',
	styleUrl: './grid-content.widget.scss'
})
export class GridContentWidget<RowT extends { updatedUTC: number }> {

	public readonly layout = inject(DashboardLayoutService);

	public readonly setup = input.required<GridSetup<RowT>>();
	public readonly namedSize = input.required<'PageContent' | 'TabContent' | 'BootstrapDialogContent' | 'CustomHeight'>();
	public readonly pageTabsGridSize = input<PageTabsMainTabGridSize>();
	/** @deprecated - Used with the old BootstrapDialogService */
	public readonly dialogOtherContentsSize = input<number>(0); // A defined height when the namedSize is BootstrapDialogContent
	public readonly customHeight = input<number>(500); // A defined height when the namedSize is CustomHeight
	public readonly rows = input.required<RowT[]>();
	public selectedRows = output<RowT[]>();

	public readonly size = computed(() => {
		const name = this.namedSize();

		if (name == 'PageContent') {
			const dims = this.layout.dimensions();
			const s: GridSize = {
				width: dims.contentWidth,
				height: dims.contentHeight,
			};
			return s;
		}
		else if (name == 'TabContent') {
			const pageTabsGridSize = this.pageTabsGridSize();
			if (!pageTabsGridSize) throw new Error('pageTabsGridSize input missing!')

			const dims = pageTabsGridSize.layout;
			if (dims) {

				let height = dims.tab1ContentHeight;

				if (pageTabsGridSize.viewSelector) height -= dims.tab1ViewDroplistHeight;

				const s: GridSize = {
					width: dims.tab1ContentWidth,
					height,
				};
				return s;
			}
			else throw new Error('pageTabsGridSize layout missing!')

		}
		else if (name == 'BootstrapDialogContent') {
			const s: GridSize = {
				height: this.layout.dialogHeight() - this.dialogOtherContentsSize(),
			};
			return s;
		}
		else if (name == 'CustomHeight') {
			const s: GridSize = {
				height: this.customHeight(),
			};
			return s;
		}
			
		else {
			throw new Error('Only PageContent or TabContent grid size calculation implemented!')
		}
	});

	getSelectedRows($event: RowT[]) {
		this.selectedRows.emit($event);
	}
}
